import React, { useEffect, useState } from 'react';
import { getCycles } from '../../api/cycleService';
import './flowchart.css';
import StageBasedCycleDetails from './StageBasedCycleDetails';
import { Link } from 'react-router-dom';

const StageBased = () => {
  const [cycles, setCycles] = useState([]);
  const [selectedCycle, setSelectedCycle] = useState(cycles[0]);
  const [popupState, setPopupState] = useState(false);

  useEffect(() => {
    loadCycles();
  }, []);


  const handleOpen = (name) => {
    for (let index = 0; index < cycles.length; index++) {
      const cycle = cycles[index];
      if (cycle.cycleName === name) {
        setSelectedCycle(cycle);
        setPopupState(true);
      }
    }
  };

  const loadCycles = async () => {
    const { data } = await getCycles();
    setCycles(data);
  };
  if (cycles.length < 1) return (
    <>
      <div class="flex items-center justify-center w-full h-[90vh]">
        <div role="status">
          <svg aria-hidden="true" class="w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" /><path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" /></svg>
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </>
  )
  return (
    <>

      {(popupState) ? (<StageBasedCycleDetails setPopupState={setPopupState} cycle={selectedCycle} />) : ('')}
      <div className='w-full min-w-[1174.78px]'>

        <nav class="fixed top-0 w-full shadow-md z-10 bg-white dark:bg-gray-950 dark:border-gray-700 "
          style={{
            backgroundImage: "url('/images/bg_img.svg')",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover"
          }} >
          <div class="max-w-screen-xl flex flex-wrap items-center justify-between mx-auto px-4">
            <Link to={'/dashboard/strategy/'}>
              <button type="button" class="flex text-gray-900 bg-white border border-gray-300 focus:outline-none hover:bg-gray-100 focus:ring-4 focus:ring-gray-100 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-gray-800 dark:text-white dark:border-gray-600 dark:hover:bg-gray-700 dark:hover:border-gray-600 dark:focus:ring-gray-700">
                <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" className='me-2' fill="currentColor"><path d="m313-440 224 224-57 56-320-320 320-320 57 56-224 224h487v80H313Z" /></svg>
                Go Back
              </button>
            </Link>

            <div class="hidden w-full md:block md:w-auto" id="navbar-solid-bg">
              <span
                class="self-center text-2xl font-semibold whitespace-nowrap text-gray-700 dark:text-white">
                Communication Strategy for Stage Based 2025
              </span>
            </div>
            <span class="flex h-16 w-30 items-center space-x-3 rtl:space-x-reverse"> </span>
          </div>
        </nav>

        <div className="relative my-24 mx-auto w-[1174.78px] h-[865.93px]" style={{
          backgroundImage: `url('/images/StageBasedTop.webp')`,
          backgroundSize: 'contain',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center center'
        }}>
          {/* To All Leads */}
          <div onClick={() => handleOpen('Cycle 1')} class="absolute left-0 top-[678px] rounded-lg rounded-lg cursor-pointer bg-yellow-300 font-semibold p-2.5 w-48 text-center">
            <span>Cycle 1</span>
          </div>
          {/* General */}
          <div onClick={() => handleOpen('General 1')} class="absolute left-[974px] top-[678px] rounded-lg rounded-lg cursor-pointer bg-yellow-300 font-semibold p-2.5 w-48 text-center">
            <span>General 1</span>
          </div>
          {/* Type A Programme */}
          <div className='absolute left-[307px] top-[825px] flex flex-col items-center'>
            <div onClick={() => handleOpen('Cycle 0')} class="rounded-lg cursor-pointer bg-yellow-300 font-semibold p-2 w-44 text-center">
              <span>Cycle 0</span>
            </div>
            <div class="w-0.5 h-8 bg-gray-700"></div>
            <div onClick={() => handleOpen('Cycle 2.1')} class="rounded-lg cursor-pointer bg-yellow-300 font-semibold p-2 w-44 text-center">
              <span>Cycle 2.1</span>
            </div>
            <div class="w-0.5 h-8 bg-gray-700"></div>
            <div onClick={() => handleOpen('Cycle 2.2')} class="rounded-lg cursor-pointer bg-yellow-300 font-semibold p-2 w-44 text-center">
              <span>Cycle 2.2</span>
            </div>
            <div class="w-0.5 h-8 bg-gray-700"></div>
            <div onClick={() => handleOpen('Cycle 2.3')} class="rounded-lg cursor-pointer bg-yellow-300 font-semibold p-2 w-44 text-center">
              <span>Cycle 2.3</span>
            </div>
            <div class="w-0.5 h-8 bg-gray-700"></div>
            <div onClick={() => handleOpen('Cycle 2.4')} class="rounded-lg cursor-pointer bg-yellow-300 font-semibold p-2 w-44 text-center">
              <span>Cycle 2.4</span>
            </div>
            <div class="w-0.5 h-8 bg-gray-700"></div>
            <div onClick={() => handleOpen('Cycle 2.8')} class="rounded-lg cursor-pointer bg-yellow-300 font-semibold p-2 w-44 text-center">
              <span>Cycle 2.8</span>
            </div>
            <div class="w-0.5 h-8 bg-gray-700"></div>
            <div onClick={() => handleOpen('Cycle 2.9')} class="rounded-lg cursor-pointer bg-yellow-300 font-semibold p-2 w-44 text-center">
              <span>Cycle 2.9</span>
            </div>
            <div class="w-0.5 h-8 bg-gray-700"></div>
            <div onClick={() => handleOpen('Cycle 3 (M)')} class="rounded-lg cursor-pointer bg-yellow-300 font-semibold p-2 w-44 text-center">
              <span>Cycle 3 (M)</span>
            </div>
            <div class="w-0.5 h-8 bg-gray-700"></div>
            <div onClick={() => handleOpen('Cycle 4')} class="rounded-lg cursor-pointer mb-12 bg-yellow-300 font-semibold p-2 w-44 text-center">
              <span>Cycle 4</span>
            </div>
          </div>
          {/* Type B Programme */}
          <div className='absolute left-[512px] top-[825px] flex flex-col items-center'>
            <div onClick={() => handleOpen('Cycle 0')} class="rounded-lg cursor-pointer bg-yellow-300 font-semibold p-2 w-44 text-center">
              <span>Cycle 0</span>
            </div>
            <div class="w-0.5 h-8 bg-gray-700"></div>
            <div onClick={() => handleOpen('Cycle 2.1')} class="rounded-lg cursor-pointer bg-yellow-300 font-semibold p-2 w-44 text-center">
              <span>Cycle 2.1</span>
            </div>
            <div class="w-0.5 h-8 bg-gray-700"></div>
            <div onClick={() => handleOpen('Cycle 2.2')} class="rounded-lg cursor-pointer bg-yellow-300 font-semibold p-2 w-44 text-center">
              <span>Cycle 2.2</span>
            </div>
            <div class="w-0.5 h-8 bg-gray-700"></div>
            <div onClick={() => handleOpen('Cycle 2.3')} class="rounded-lg cursor-pointer bg-yellow-300 font-semibold p-2 w-44 text-center">
              <span>Cycle 2.3</span>
            </div>
            <div class="w-0.5 h-8 bg-gray-700"></div>
            <div onClick={() => handleOpen('Cycle 2.4')} class="rounded-lg cursor-pointer bg-yellow-300 font-semibold p-2 w-44 text-center">
              <span>Cycle 2.4</span>
            </div>
            <div class="w-0.5 h-8 bg-gray-700"></div>
            <div onClick={() => handleOpen('Cycle 2.5')} class="rounded-lg cursor-pointer bg-yellow-300 font-semibold p-2 w-44 text-center">
              <span>Cycle 2.5</span>
            </div>
            <div class="w-0.5 h-8 bg-gray-700"></div>
            <div onClick={() => handleOpen('Cycle 2.6')} class="rounded-lg cursor-pointer bg-yellow-300 font-semibold p-2 w-44 text-center">
              <span>Cycle 2.6</span>
            </div>
            <div class="w-0.5 h-8 bg-gray-700"></div>
            <div onClick={() => handleOpen('Cycle 2.7')} class="rounded-lg cursor-pointer bg-yellow-300 font-semibold p-2 w-44 text-center">
              <span>Cycle 2.7</span>
            </div>
            <div class="w-0.5 h-8 bg-gray-700"></div>
            <div onClick={() => handleOpen('Cycle 3')} class="rounded-lg cursor-pointer bg-yellow-300 font-semibold p-2 w-44 text-center">
              <span>Cycle 3 (M)</span>
            </div>
            <div class="w-0.5 h-8 bg-gray-700"></div>
            <div onClick={() => handleOpen('Cycle 4')} class="rounded-lg cursor-pointer mb-12 bg-yellow-300 font-semibold p-2 w-44 text-center">
              <span>Cycle 4</span>
            </div>
          </div>
          {/* Type C Programme */}
          <div className='absolute left-[716px] top-[825px] flex flex-col items-center'>
            <div onClick={() => handleOpen('Cycle 0 (M)')} class="rounded-lg cursor-pointer bg-yellow-300 font-semibold p-2 w-44 text-center">
              <span>Cycle 0 (M)</span>
            </div>
            <div class="w-0.5 h-8 bg-gray-700"></div>
            <div onClick={() => handleOpen('Cycle 3')} class="rounded-lg cursor-pointer bg-yellow-300 font-semibold p-2 w-44 text-center">
              <span>Cycle 3</span>
            </div>
            <div class="w-0.5 h-8 bg-gray-700"></div>
            <div onClick={() => handleOpen('Cycle 4')} class="rounded-lg marker:cursor-pointer mb-12 bg-yellow-300 font-semibold p-2 w-44 text-center">
              <span>Cycle 4</span>
            </div>
          </div>
        </div>
        <div className='mb-12'></div>
      </div >
    </>
  );
};

export default StageBased;
